export default {
  "name": "R from: Light",
  "slug": "r-from-light",
  "path": "/r-from-light",
  "componentName" : "RFromLight",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}